module.exports = __webpack_public_path__ + "static/media/prostateguard1.8ab477bc.jpg";